/* eslint-disable */ 
import {useState, useEffect } from "react";
import { Flex, Text, Icon, useColorModeValue, useToast, Spinner  } from '@chakra-ui/react'; 
import { TbFileInvoice } from 'react-icons/tb';

import { useParams, Redirect } from 'react-router-dom'

// Custom components   

import CommonDatatable from 'components/datatable/CommonDatatable';
import Header from 'views/publico/webTracking/components/Header';
import EmptyState from 'views/publico/webTracking/components/EmptyState';
import Loading from 'views/publico/webTracking/components/Loading';

import service from 'services/webTrackingService';

import { 
  createColumnHelper
} from '@tanstack/react-table'
  
type RowObj = {
	cia: string;
	exp_House: number;
	exp_Aduana: number;
	cod_Etapa: string;
	nom_Etapa: string;
	fecha: string;
	hora_Etapa: string;
	oficina: string;
	observacion: string;
	embarque: string;
	nom_Embarcador: string;
	cod_Consignatario: string;
	nom_Consignatario: string;
	doc_Transp: string;
	f_Llegada: number;
	operacion: string;
	vuelo: string;
	motonave: string;
	viaje: string;
	origen: string;
	destino: string;
	tipo: string;
	referencia: string;
	fechaUnida: string;
	ord_Etapa: string;
	fechaString: string;
};

import { EXPORT_TITLE, EXPORT_DESCRIPTION, TIME_CACHE_LONG } from "const/CommonConst";

export default function DataTable() {

  let { id } = useParams();

  if (id === undefined || id === null || id === '') {
    return <EmptyState />
  }
  
  const textColor = useColorModeValue("navy.700", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");  
  const brandColor = useColorModeValue("brand.500", "brand.400");
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

  const toast = useToast()

  const [tableData, setTableData] = useState([]);
  const [headerData, setHeaderData] = useState();

  const [noData, setNoData] = useState(false);
  const [showEmptyState, setShowEmptyState] = useState(true);
  const [disabledActions, setDisabledActions] = useState(true);
  const [showProgressExport, setShowProgressExport] = useState(false);
  const [expediente, setExpediente] = useState(id);
  
    useEffect(() => document.title = `Taurel - Tracking Carga - Detalle Documento Transporte ${id}`,[]);

  const fetchData = async () => {
    return await service.getTablaDetalle(id);
  };

    useEffect(async () => {
	setExpediente(id)

	const data = await fetchData();

	if (data && data.length > 0)
	{
		const header = data[0];
		
		setTableData(data)
		setHeaderData(header)
		setDisabledActions(false)
        setNoData(false)
	}
	else{
        setNoData(true)
		setTableData([])
		setHeaderData()
		setDisabledActions(true)
	}
	
},[id]);

if (noData) {
    return <EmptyState expediente={id} />
}
else if (!noData && tableData.length === 0) {
    return <Loading expediente={id} />
}

  const onExportData = async () => {
	try {
	setDisabledActions(true);
	setShowProgressExport(true);
	await service.getExcelDetalle(id);
	toast({
		title: EXPORT_TITLE,
		description: EXPORT_DESCRIPTION,
		status: 'success',
		duration: 9000,
		isClosable: true,
	  });
}
  finally{
	setDisabledActions(false);
	setShowProgressExport(false);
  }
  };



    const columnHelper = createColumnHelper<RowObj>();
 	const columns = [
		columnHelper.accessor('fechaString', {
			id: 'fechaString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					FECHA
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),		
		columnHelper.accessor('nom_Etapa', {
			id: 'nom_Etapa',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					SEGUIMIENTO
				</Text>
			),
			cell: (info) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),		
		columnHelper.accessor('observacion', {
			id: 'observacion',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        OBSERVACIÓN
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				
			</Text>
			)
		})  
	];

  return ( 
    <CommonDatatable
    columnsDefinition={columns}
    tableData={tableData}
	showEmptyState={showEmptyState}
	isLoading={disabledActions}
    actionContent={    
        <Header data={headerData} expediente={id}  /> }
      />        
  )
} 
